import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/WebUI/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import TilesTable from 'components/Web_User_Interface/1440p_Series/System/WebUI/tilesTable';
import VideoWebUIWidgets from 'components/Web_User_Interface/1440p_Series/System/WebUI/VideoWebUIWidgets';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  TilesTable,
  VideoWebUIWidgets,
  BreadCrumbs,
  SEOHelmet,
  React
};